import { DOCUMENT } from '@angular/common';
import { Component, Inject, Input, OnInit, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { MustMatch } from '@app/modules/central-login/util/must-match.validator';
import {
    CentralLoginAccountSettingsComponent
} from '@app/modules/central-login/pages/central-login-account-settings.component';
import { Toaster } from 'psd-common';
import {
    AuthenticationService,
    CookieUtil,
    PasswordStrengthValidator,
    ChangePasswordDTO,
    CookieService,
    UserDTO,
    CommonUtil,
    CommonUserService
} from 'psd-common';
import { environment } from '../../../../environments/environment';
import { PublicUtil } from '@app/modules/central-login/util/public-util';

@Component({
    selector: 'central-login-account-settings-navigation',
    templateUrl: 'central-login-account-settings-navigation.component.html'
})
export class CentralLoginAccountSettingsNavigationComponent extends CentralLoginAccountSettingsComponent implements OnInit {
    @Input('page') page: string = 'personal-info';
    public changePasswordForm: FormGroup;
    public submitted: boolean = false;
    public submitting: boolean = false;
    public currentUser: UserDTO;
    public checkPassword: any = {};
    public requestCentralAccessToken: string;
    public requestCentralRefreshToken: string;
    public CommonUtil: typeof CommonUtil = CommonUtil;

    constructor(@Inject(DOCUMENT) private document: Document,
                private renderer: Renderer2,
                private toaster: Toaster,
                private route: ActivatedRoute,
                private formBuilder: FormBuilder,
                private translateService: TranslateService,
                private userService: CommonUserService,
                public authenticationService: AuthenticationService,
                public cookieService: CookieService) {
        super(cookieService, authenticationService);
    }

    ngOnInit() {
        this.renderer.removeClass(this.document.body, 'login');
        this.renderer.addClass(this.document.body, 'central-login__dashboard');
        this.changePasswordForm = this.formBuilder.group(
            {
                currentPassword: ['', [Validators.required, Validators.minLength(8)]],
                newPassword: ['', [Validators.required, Validators.minLength(8), PasswordStrengthValidator()]],
                repeatPassword: ['', Validators.required]
            },
            {
                validator: MustMatch('newPassword', 'repeatPassword')
            }
        );

        this.checkCookiesAndSetUser();
    }

    getCurrentUser() {
        this.currentUser = PublicUtil.getCentralUser();
    }

    get form() {
        return this.changePasswordForm.controls;
    }

    save() {
        let centralAccessToken = this.cookieService.getCentralCookie('central_access_token', environment.production);
        this.submitted = true;
        this.submitting = true;

        if (this.changePasswordForm.invalid || CommonUtil.checkInvalidPassword(this.checkPassword)) {
            this.submitting = false;
            return;
        }

        let json = JSON.parse(JSON.stringify(this.changePasswordForm.value, null, 4));
        let changePasswordDTO = new ChangePasswordDTO();
        changePasswordDTO.currentPassword = json.currentPassword;
        changePasswordDTO.newPassword = json.newPassword;
        changePasswordDTO.repeatPassword = json.repeatPassword;

        this.authenticationService.changePassword(centralAccessToken, changePasswordDTO).subscribe(_result => {
            this.changePasswordForm.setValue({
                'currentPassword': '',
                'newPassword': '',
                'repeatPassword': ''
            });

            this.changePasswordForm.setErrors({});
            this.submitted = false;
            this.submitting = false;
            this.toaster.success(this.translateService.instant('central-login.change.password.success'));
        }, _error => {
            this.toaster.error(this.translateService.instant('central-login.change.password.error'));
            this.submitting = false;
        });
    }

    checkPasswordStrength(event: any) {
        this.checkPassword = CommonUtil.checkPassWordStrength(event.target.value);
    }

    checkPasswordConfirmation(event: any) {
        if (event.target.value != '' && event.target.value != this.changePasswordForm.controls['newPassword'].value) {
            this.form.repeatPassword.setErrors({mustMatch: true});
        }
    }

    togglePassword(event: any) {
        const password = document.querySelector('#password');
        const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
        password.setAttribute('type', type);
        event.target.classList.toggle('fa-eye-slash');

    }
}
